import React from "react";

import { Close, Error, Replay } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

import {
  OrderVariantErrorType,
  TOrderVariantError,
} from "src/redux/slices/ordering/orderSetSlice";

import { PaperTooltip } from "@features/ui";

const OrderVariantError = ({
  error,
  retry,
  clear,
  isPending,
}: {
  error: TOrderVariantError;
  retry: () => void;
  clear: () => void;
  isPending: boolean;
}) => {
  return (
    <div className="flex gap-1 items-center rounded px-1 bg-red-50 border border-red-200">
      <PaperTooltip title={error.error}>
        <div className="py-px text-xs uppercase flex items-center gap-1">
          <Error className="text-red-400 text-base" />
          {error.maxQuantity && (
            <span className="text-red-400 font-medium">
              max {error.maxQuantity}
            </span>
          )}
          {error.type === OrderVariantErrorType.OVER_BUDGET && (
            <span className="text-red-400 font-medium">over budget</span>
          )}
        </div>
      </PaperTooltip>
      <Tooltip title="Retry">
        <IconButton
          onClick={retry}
          size="small"
          disabled={isPending}
          className="-my-3 -mx-1.5 ml-0"
        >
          <Replay className="text-base text-red-500 -scale-x-100" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Clear">
        <IconButton
          onClick={clear}
          size="small"
          disabled={isPending}
          className="-my-3 -mx-1.5"
        >
          <Close className="text-base text-red-500" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default React.memo(OrderVariantError);
